import { render } from "./sendGoogd.vue?vue&type=template&id=638cab3d&scoped=true"
import script from "./sendGoogd.vue?vue&type=script&lang=js"
export * from "./sendGoogd.vue?vue&type=script&lang=js"

import "./sendGoogd.vue?vue&type=style&index=0&id=638cab3d&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638cab3d"]])

export default __exports__